export const Row = ({ label, value, breakAll, mono }) => (
  <div className='flex items-center justify-between gap-2'>
    <span className='text-gray-500 uppercase text-xs tracking-wide'>
      {label}
    </span>
    <span className={`text-xs font-semibold text-gray-700 text-right max-w-[55%] break-all ${mono ? 'font-mono bg-gray-100 px-1.5 py-0.5 rounded text-[11px] border border-gray-200' : ''}`}>
      {value || '—'}
    </span>
  </div>
)